module.exports = __webpack_public_path__ + "static/img/07ko.9af0acc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/06/07ko.jpg
// module id = UvjH
// module chunks = 0